// Thievery API client for SF-27

import { api } from './client';
import type { ThieveryRequest, ThieveryResponse } from '../types/thievery';

/**
 * Execute a thievery operation against a target province
 * @param worldId - The world ID
 * @param provinceId - The attacker's province ID
 * @param request - Thievery request with target and operation
 * @returns Thievery result and updated province
 */
export async function conductThieveryOperation(
  worldId: string,
  provinceId: string,
  request: ThieveryRequest
): Promise<ThieveryResponse> {
  const response = await api.post<ThieveryResponse>(
    `/api/worlds/${worldId}/provinces/${provinceId}/thievery`,
    request
  );
  if (response.error || !response.data) {
    throw new Error(response.error || 'Failed to conduct thievery operation');
  }
  return response.data;
}
